import { useState, useEffect, } from "react";
import {
  useCourseOptions,
  useModuleByIdOptions,
  useTopicByIdOptions,
} from "../../hooks/dropdownOptions";

export const useFormConfig = (question, mode) => {
  const [selectedCourseId, setSelectedCourseId] = useState(question?.course_id
    || null);
  const [selectedModuleId, setSelectedModuleId] = useState(question?.module_id || null);
  const topicOptions = useTopicByIdOptions(selectedModuleId);
  const courseOptions = useCourseOptions();
  const moduleOptions = useModuleByIdOptions(selectedCourseId);
  useEffect(() => {
    if (question?.course_id
    ) {
      setSelectedCourseId(question?.course_id
      );
    }
    if (question?.module_id) {
      setSelectedModuleId(question?.module_id);
    }
  }, [question?.course_id
    , question?.module_id]);

  const titleFieldType = mode === "update" ? "text" : "inputtranslation";

  return {
    questionForm: {
      formTitle: "Question",
      initialFormData: {
        courseId: null,
        moduleId: "",
        topicId: "",
        languageId: "",
        text: "",
        totalOptions: "",
        isMultiselect: "",
        answers: "",
      },
      fieldConfig: [
        {
          key: "courseId",
          label: "Course",
          type: "dropdown",
          options: courseOptions,
          placeholder: "Select a course",
          required: true,
          onChange: (e) => { setSelectedCourseId(e.value); }
        },
        {
          key: "moduleId",
          label: "Module",
          type: "dropdown",
          options: moduleOptions,
          placeholder: "Select a Module",
          required: true,
          onChange: (e) => { setSelectedModuleId(e.value); }
        },
        {
          key: "topicId",
          label: "Topic",
          type: "dropdown",
          options: topicOptions,
          placeholder: "Select a Topic",
          required: true,
        },
        {
          key: "text",
          label: "Question",
          type: titleFieldType,
          placeholder: "Enter Question",
          required: true,
          alphaOnly: true
        },
        {
          key: "totalOptions",
          label: "Total Options",
          type: "text",
          placeholder: "Enter Total No of Options",
          required: true,
        },
        {
          key: "answers",
          label: "Options",
          type: titleFieldType,
          placeholder: "Enter Options",
          required: true,
        },
      ],
    },
  };
};